
 //import get  from "https";
  
 const getApi = (url) => `${window.config.api}/${url}`;

// 基础信息
 export const BASE_INFO = getApi('Generic/BaseInfo')
 //头部导航
 export const NAV_INFO = getApi('Generic/NavInfo')
//查询
export const QUERY_SEARCH= getApi('Search/QueryGeneralRecords')
//分页查询
export const QUERY_SEARCHPAGE=getApi('Search/QueryGeneralRecordsPages')
//
export const QUERY_INFO= getApi('Info/QueryBookInfo')
//朝代/国别
export const QUERY_CDGB=getApi('Generic/GetCdgbInfo');
//著者 朝代/国别
export const QUERY_AUTHERCDGB=getApi('Search/QueryAutherCdgb');
//著者查询
export const QUERY_AUTHER=getApi('Search/QueryAuthorRecords');
//分页著者查询
export const QUERY_AUTHERPAGE=getApi('Search/QueryAuthorPageRecords');
//著者详细界面
export const QUERY_INFOAUTHOR=getApi('Info/QueryAuthorInfo');
//子目检索
export const QUERY_BOOINDEX=getApi('Search/QueryBookIndexRecords');
//子目分页
export const QUERY_BOOKINDEXPAGE=getApi('Search/QueryBookIndexRecordsPage');
//篇名检索
export const QUERY_PINDEX=getApi('Search/QueryPindexRecords');
export const QUERY_PINDEXPAGE=getApi('Search/QueryPindexRecordsPage');
//获取图片 
export const QUERY_FOLDERPICTURE=getApi('Info/GetFolderPicture');
//获取大图
export const QUERY_FOLDERPICTUREMAX=getApi('Info/GetFolderPictureMax');
//登录
export const LOGIN=getApi('Generic/Login');

export const QUERYIP=getApi('Generic/GetIP');

export const SEND_EMAIL=getApi('Generic/SendEmail');
 
 export const DOW_Image=getApi('dowFile/DowImage');